export { default } from './useLinkHandling';
export * from './useLinkHandling';
